import React, { useEffect, useState } from "react";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import { RootState } from "../../../../redux/rootReducer";
import {
  FGrid,
  FButton,
  FTable,
  FItem,
  FTruncateText,
  FContainer,
  FTypo,
  FGridItem,
} from "ferrum-design-system";
import { useDispatch, useSelector } from "react-redux";
import {
  useWalletConnector,
  useAlgoSignerWalletConnector,
  useKeplrWalletConnector,
} from "foundry";
import { MY_TRADES_HEADER, truncateText } from "../../../../utils/constants";
import * as swapAndWithdrawActions from "../../../../redux/slices/swap";
import completedIcon from "../../../../assets/ms-new-images/icons/ms-btn-completed-icon.png";
import pendingIcon from "../../../../assets/ms-new-images/icons/ms-btn-pending-icon.png";
import failedIcon from "../../../../assets/ms-new-images/icons/ms-btn-failed-icon.png";
import { BsSearch } from "react-icons/bs";
import MultiSwapBeta from "../../../../assets/img/multiswap-banner.svg";
import MultiSwapBetaMobile from "../../../../assets/img/multiswap-banner-mobile.svg";
import StatusIcon from "../../../../assets/ms-new-images/icons/detail-icon.svg";
// import hashIcon from "../../../../assets/ms-new-images/icons/hashicon.svg";
import ExplorerIcon from "../../../../assets/ms-new-images/icons/explorer-icon.svg";
import ReactTooltip from "react-tooltip";
import useWindowSize from "../../../../hooks/useWindowSize";
import { Table } from "react-bootstrap";
import MyTradesDetailDialog from "../../components/dialogs/MyTradesDetailDialog";
import {
  copyTextToClipboard,
  openTransactionOnExplorer,
} from "../../../../utils/helperFunctions";
import { ProviderAssetsLogo } from "../../../../utils/constants";
import { DEFAULT_TOKEN_LOGO } from "../../../../utils/const.utils";

// Randomize data of the table columns.
// Note that the fields are all using the `prop` field of the headers.

const MyTradesPage = () => {
  const dataLimit = 10;
  const [width] = useWindowSize();
  const dispatch = useDispatch();
  const [offSet, setOffSet] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState("");
  const [body, setBody] = useState<Array<any>>([]);
  const [searchByValue, setSearchByValue] = useState("");
  const [isTable, setIsTable] = useState(true);

  const [showTransactionInfo, setShowTransactionInfo] =
    useState<boolean>(false);

  const { isConnected, walletAddress } = useWalletConnector();
  const { isAlgoConnected } = useAlgoSignerWalletConnector();
  const { isKeplrConnected } = useKeplrWalletConnector();

  const {
    swapAndWithdrawTxList,
    isSwapAndWithdrawTxsLoading,
    tokenV2: token,
  } = useSelector((state: RootState) => ({
    ...state.swap,
    ...state.walletAuthenticator,
  }));

  useEffect(() => {
    getSwapAndWithdrawTransactions(0);
  }, [token, searchByValue]);

  useEffect(() => {
    if (swapAndWithdrawTxList && swapAndWithdrawTxList?.length) {
      refactoringTransactions();
    } else {
      setBody([]);
    }
    // eslint-disable-next-line
  }, [swapAndWithdrawTxList]); //responseData

  const searchMyTradesTransaction = (txId: string) => {
    setSearchByValue(txId);
  };

  const getSwapAndWithdrawTransactions = (offset: any) => {
    if (token) {
      dispatch(
        swapAndWithdrawActions.getSwapAndWithdrawTransactions(
          offset,
          searchByValue
        )
      );
    }
  };

  const refactoringTransactions = () => {
    let result = swapAndWithdrawTxList.map((item) => {
      function formatDate(dateString: string | number | Date) {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        const date = new Date(dateString);
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        const formattedTime = date.toISOString().split("T")[1].split(".")[0];

        return `${day}-${months[monthIndex]}-${year} ${formattedTime}`;
      }

      const handlOpenDetails = () => {
        setShowTransactionInfo(true);
        setSelectedItem(item);
      };

      return {
        from: (
          <div>
            <FItem display={"flex"} alignY={"center"}>
              <img
                src={item?.sourceNetwork?.logo}
                alt={"Network Logo"}
                width="20px"
              />{" "}
              <img
                src={item?.sourceCabn?.currency?.logo || DEFAULT_TOKEN_LOGO}
                alt={"Currency Logo"}
                width="20px"
              />
              {item?.sourceAmount && (
                <>
                  <a
                    className="d-flex ai ai-center jc jc-center"
                    data-tooltip-id={item.sourceWalletAddress}
                    data-tip={`${item.sourceWalletAddress}`}
                    data-for={item.sourceWalletAddress}
                  >
                    <span className="custom-font-size-12 f-mr--5">
                      {Number(item?.sourceAmount).toFixed(2)}
                    </span>
                    <span className="custom-font-size-12">
                      {item.sourceCabn?.currency?.symbol ||
                        item.sourceCabn?.nonDefaultCurrencyInformation?.symbol}
                    </span>
                  </a>
                  <ReactTooltip id={item?.sourceWalletAddress}>
                    <span>{item?.sourceWalletAddress}</span>
                  </ReactTooltip>
                </>
              )}
            </FItem>
          </div>
        ),
        to: (
          <div>
            <FItem display={"flex"} alignY={"center"}>
              <img
                src={item?.destinationNetwork?.logo}
                alt={"Network Logo"}
                width="20px"
              />
              <img
                src={
                  item?.destinationCabn?.currency?.logo || DEFAULT_TOKEN_LOGO
                }
                alt={"Network Logo"}
                width="20px"
              />
              {item?.destinationAmount && (
                <>
                  <a
                    className="d-flex ai ai-center jc jc-center"
                    data-tooltip-id={item.destinationWalletAddress}
                    data-tip={`${item.destinationWalletAddress}`}
                    data-for={item.destinationWalletAddress}
                  >
                    <span className="custom-font-size-12 f-mr--5">
                      {Number(item?.destinationAmount).toFixed(2)}
                    </span>
                    <span className="custom-font-size-12">
                      {item.destinationCabn?.currency?.symbol ||
                        item.destinationCabn?.nonDefaultCurrencyInformation
                          ?.symbol}
                    </span>
                  </a>
                  <ReactTooltip id={item?.destinationWalletAddress}>
                    <span>{item?.destinationWalletAddress}</span>
                  </ReactTooltip>
                </>
              )}
            </FItem>
          </div>
        ),

        dateUTC: (
          <div className="custom-font-size-10 text-center">
            {item && item.createdAt && formatDate(item.createdAt)}
          </div>
        ),
        fromHash: (
          <div>
            <FItem display={"flex"} alignY={"center"}>
              <>
                <a
                  data-tooltip-id={item?.receiveTransactionId}
                  data-tip={`${item?.receiveTransactionId}`}
                  data-for={item?.receiveTransactionId}
                  onClick={() => {
                    copyTextToClipboard(item?.receiveTransactionId);
                  }}
                  className="cursor-pointer"
                >
                  <FTypo size={10}>
                    {truncateText(item?.receiveTransactionId, 5, "center")}
                  </FTypo>
                </a>

                <ReactTooltip id={item?.receiveTransactionId}>
                  <span>{item?.receiveTransactionId}</span>
                </ReactTooltip>
              </>{" "}
              <img
                src={ExplorerIcon}
                alt={"Explorer Icon"}
                width="15px"
                height="15px"
                className="cursor-pointer"
                style={{ marginLeft: "0.5rem" }}
                onClick={() =>
                  window.open(
                    openTransactionOnExplorer(
                      item?.sourceNetwork?.blockExplorerUrl,
                      item?.receiveTransactionId,
                      item?.sourceNetwork?.nameInLower
                    ),
                    "_blank"
                  )
                }
              />
            </FItem>
          </div>
        ),
        toHash: (
          <div>
            {item?.withdrawTransactions[0]?.transactionId ? (
              <FItem display={"flex"} alignY={"center"}>
                <>
                  <a
                    data-tooltip-id={
                      item?.withdrawTransactions[0]?.transactionId
                    }
                    data-tip={`${item?.withdrawTransactions[0]?.transactionId}`}
                    data-for={item?.withdrawTransactions[0]?.transactionId}
                    onClick={() => {
                      copyTextToClipboard(
                        item?.withdrawTransactions[0]?.transactionId
                      );
                    }}
                    className="cursor-pointer"
                  >
                    <FTypo size={10}>
                      {truncateText(
                        String(item?.withdrawTransactions[0]?.transactionId),
                        5,
                        "center"
                      )}
                    </FTypo>
                  </a>

                  <ReactTooltip
                    id={item?.withdrawTransactions[0]?.transactionId}
                  >
                    <span>{item?.withdrawTransactions[0]?.transactionId}</span>
                  </ReactTooltip>
                </>
                <img
                  src={ExplorerIcon}
                  alt={"Explorer Icon"}
                  width="15px"
                  height="15px"
                  className="cursor-pointer"
                  style={{ marginLeft: "0.5rem" }}
                  onClick={() =>
                    window.open(
                      openTransactionOnExplorer(
                        item?.destinationNetwork?.blockExplorerUrl,
                        item?.withdrawTransactions[0]?.transactionId,
                        item?.destinationNetwork?.nameInLower
                      ),
                      "_blank"
                    )
                  }
                />
              </FItem>
            ) : null}
          </div>
        ),

        provider: (
          <div className="text-center custom-font-size-12">
            <img
              src={ProviderAssetsLogo[item?.sourceAssetType]}
              alt={"Network Logo"}
              width={20}
              height={20}
            />{" "}
            <img
              src={ProviderAssetsLogo[item?.destinationAssetType]}
              alt={"network Logo"}
              width={20}
              height={20}
            />
          </div>
        ),

        status: (
          <div className="col-actions">
            {item.status === "swapWithdrawCompleted" ? (
              <FButton
                className={"ms-table-buttons btn-completed"}
                title={"Completed"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={completedIcon}
                    alt="completedIcon"
                  />
                }
              />
            ) : item.status === "swapWithdrawFailed" ? (
              <FButton
                className={"ms-table-buttons btn-failed"}
                title={"Withdraw Failed"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={failedIcon}
                    alt="failedIcon"
                  />
                }
              />
            ) : item.status === "swapWithdrawPending" ? (
              <FButton
                className={"ms-table-buttons btn-pending"}
                title={"Withdraw Pending"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={pendingIcon}
                    alt="pendingIcon"
                  />
                }
              />
            ) : item.status === "swapWithdrawGenerated" ? (
              <FButton
                className={"ms-table-buttons btn-pending"}
                title={"Withdraw Signature Generated"}
                // disabled={true}
                outlined
                onClick={() => {
                  setShowTransactionInfo(true);
                  setSelectedItem(item);
                }}
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={completedIcon}
                    alt="completedIcon"
                  />
                }
              />
            ) : item.status === "swapCompleted" ? (
              <FButton
                className={"ms-table-buttons btn-completed"}
                title={"Swapped"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={completedIcon}
                    alt="completedIcon"
                  />
                }
              />
            ) : item.status === "swapCreated" ? (
              <FButton
                className={"ms-table-buttons btn-completed"}
                title={"Swap Created"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={completedIcon}
                    alt="completedIcon"
                  />
                }
              />
            ) : item.status === "swapPending" ? (
              <FButton
                className={"ms-table-buttons btn-pending"}
                title={"Swap Pending"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={failedIcon}
                    alt="failedIcon"
                  />
                }
              />
            ) : item.status === "swapFailed" ? (
              <FButton
                className={"ms-table-buttons btn-failed"}
                title={"Swap Failed"}
                outlined
                prefix={
                  <img
                    width={"15px"}
                    className="f-mt--4"
                    src={failedIcon}
                    alt="failedIcon"
                  />
                }
              />
            ) : (
              <div>
                <FButton
                  className={"ms-table-buttons btn-pending"}
                  variant={"secondary"}
                  title={"Swapped"}
                  outlined
                />
              </div>
            )}
          </div>
        ),
        details: (
          <div className="text-center">
            <img
              className="cursor-pointer"
              onClick={handlOpenDetails}
              src={StatusIcon}
              alt="StatusIcon"
              height={20}
              width={20}
            />
          </div>
        ),
      };
    });
    setBody(result);
  };

  const SetPagination = () => {
    return (
      <div className={"d_flex justify_end align_center f-mb-6 nextprev-m"}>
        {page > 1 && (
          <div
            className={" prev-m cursor_pointer"}
            onClick={() => {
              if (isSwapAndWithdrawTxsLoading) {
              } else {
                setPage(page - 1);
                getSwapAndWithdrawTransactions(offSet > 0 ? offSet - 10 : 0);
                setOffSet(offSet - 10);
              }
            }}
          >
            <FTypo
              size={14}
              weight={400}
              color={`${isTable ? "#ffffff" : "#ffffff"}`}
              className={""}
            >
              Prev
            </FTypo>
          </div>
        )}

        <div
          className={`active-page-btn f-ml-1${isTable && "bg_white clr_black"}`}
        >
          {page}
        </div>
        {swapAndWithdrawTxList.length === dataLimit && (
          <div
            className={"cursor_pointer f-ml-1"}
            onClick={() => {
              if (isSwapAndWithdrawTxsLoading) {
              } else {
                setPage(page + 1);
                getSwapAndWithdrawTransactions(offSet + 10);
                setOffSet(offSet + 10);
              }
            }}
          >
            <FTypo
              size={14}
              weight={400}
              color={`${isTable ? "#ffffff" : "#ffffff"}`}
              className={""}
            >
              Next
            </FTypo>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isConnected || isAlgoConnected || isKeplrConnected ? (
        <FContainer width={1500} className={"my-trades-container"}>
          <img src={MultiSwapBeta} className="metamask-beta-img" />
          <img src={MultiSwapBetaMobile} className="metamask-beta-mobile" />
          <div className="ms-trades-header f-mt--7 f-mb--10">
            <span>
              <FTypo size={20}>My Trades</FTypo>
            </span>
            <div className="ms-trades-header-input">
              <input
                placeholder="Search Transaction Hash"
                value={searchByValue}
                onChange={(e) => searchMyTradesTransaction(e.target.value)}
              />
              <span className="ms-trades-search-icon">
                <BsSearch color="#7F8287" size={12} />
              </span>
            </div>
          </div>
          {isSwapAndWithdrawTxsLoading ? (
            <FTypo alignX={"center"}>Loading ...</FTypo>
          ) : (
            <>
              <FTable variant="" className="f-p-0">
                <DatatableWrapper
                  headers={MY_TRADES_HEADER}
                  body={body}
                  paginationOptionsProps={{
                    initialState: {
                      rowsPerPage: 10,
                      options: [10],
                    },
                  }}
                >
                  <Table>
                    <TableHeader
                      classes={{
                        thead: "custom-height-35 table-header-background",
                      }}
                    />
                    <TableBody
                      classes={{
                        tbody: "custom-border-radius-10",
                      }}
                    />
                  </Table>
                </DatatableWrapper>
              </FTable>
              <FGrid>
                {/* <FGridItem size={[4, 4, 4]}></FGridItem>
                <FGridItem size={[4, 4, 4]}></FGridItem> */}
                <FGridItem size={[4, 4, 4]} alignX={"center"}>
                  <SetPagination />
                </FGridItem>
              </FGrid>
            </>
          )}
        </FContainer>
      ) : (
        <div>
          <img src={MultiSwapBeta} className="metamask-beta-img" />
          <img src={MultiSwapBetaMobile} className="metamask-beta-mobile" />
          <FTypo display={"flex"} alignX={"center"}>
            No Wallet Connected
          </FTypo>
        </div>
      )}
      <MyTradesDetailDialog
        showTransactionInfo={showTransactionInfo}
        setShowTransactionInfo={setShowTransactionInfo}
        selectedItem={selectedItem}
      />
    </>
  );
};
export default MyTradesPage;
